import FloatingVue from 'floating-vue';

import 'floating-vue/dist/style.css';

export default {
    install(app) {
        app.use(FloatingVue, {
            themes: {
                'display-info-tooltip': {
                    $extend: 'tooltip',
                },
                'display-success-tooltip': {
                    $extend: 'tooltip',
                },
            },
        });
    },
};
